import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { get } from "lodash";
import { reduxForm, Field, reset, change } from "redux-form";
import { getFoodGroupList, searchFoodNutrition, resetField } from "../../../store/actions";
import { FormField } from "../../../sharedComponents/formField";
import { objToQueryString } from "../../../utils/common";
import { required } from "../../../constants/formValidators";

const SearchFoodNutrition = ({
	getFoodGroupList,
	recipeFoodGroups,
	handleSubmit,
	resetForm,
	atBottom,
	footer = null,
	searchFoodNutrition,
	afterSearch,
	resetField,
	change,
	setLoaderTrue,
	setSearch,
	getFoodListCardView,
	recipeFoodSearchKeyword,
}) => {
	const [searchText, setSearchText] = useState("");
	const [offset, setOffset] = useState(30);

	useEffect(() => {
		getFoodGroupList();
	}, [getFoodGroupList]);

	useEffect(() => {
		if (atBottom && searchText) {
			let values = { search: searchText };
			let url = `?${objToQueryString(values)}&limit=30&offset=${offset}`;
			getSearchData(values, url);
			setOffset(offset + 30);
		}
	}, [atBottom]);

	useEffect(() => {
		if (recipeFoodSearchKeyword) {
			change("SearchIngredientsForm", "search", recipeFoodSearchKeyword.search);
			change("SearchIngredientsForm", "hier1", recipeFoodSearchKeyword.hier1);
			change("SearchIngredientsForm", "useful", recipeFoodSearchKeyword.useful);
		} else {
			resetForm("SearchIngredientsForm");
		}
	}, [recipeFoodSearchKeyword, change, resetForm]);

	const onSearch = ({ target }) => {
		let values = { search: target.value };
		let url = `?${objToQueryString(values)}&limit=30`;
		setSearchText(target.value);
		setSearch(target.value);

		if (target.value) {
			if (searchText !== target.value) {
				getSearchData(values, url);
			}
		} else {
			resetSearch();
		}
	};

	const getSearchData = (values, url) => {
		setLoaderTrue(true);

		const successHandler = (res) => {
			setLoaderTrue(false);
			res.json().then((data) => {
				if (data && data.results && data.results.length) {
					resetField("FoodDatabase.foodNutritionList", data);
					afterSearch && afterSearch();
				}
				if (data && data.results && !data.results.length) {
					resetField("FoodDatabase.foodNutritionList", []);
				}
			});
		};

		if (values && values.search) {
			resetField("AddRecipe.recipeFoodSearchKeyword", values);
			searchFoodNutrition(url, successHandler);
		} else {
			NotificationManager.error("Enter search term!", "", 5000);
		}
	}

	const resetSearch = () => {
		setLoaderTrue(true);
		setSearchText("");
		resetField("FoodDatabase.foodNutritionList", []);
		getFoodListCardView();
		setOffset(30);
		setSearch("");
		setLoaderTrue(false);
	}

	const handleKeyDown = (e) => {
		onSearch(e);
	}

	const InputField = () => (
		<div className="search-wrap">
			<div className={`form-group search-field m-0 $`}>
				<input
					className="form-control"
					type="text"
					value={searchText}
					onChange={onSearch}
					onKeyPress={handleKeyDown}
					placeholder={'Search Term'}
					name={'name'}
					autoComplete="off"
					autoCorrect="off"
				/>
				{
					searchText ?
						<i className="icon icon-close" onClick={() => {
							resetSearch()
						}} />
						:
						<i className="icon icon-search" />
				}
			</div>
		</div>
	);

	return (
		<React.Fragment>
			{InputField()}
			{/* <form className="row" onSubmit={handleSubmit(handleSearch)}>
				<div className="col-12">
					<Field
						name="search"
						label="Search Term"
						placeholder="Keywords"
						type="text"
						component={FormField}
						validate={[required]}
						onChange={() => setSubmitting(false)}
					/>
				</div>
				<div className="col-12">
					<button type="submit" disabled={submitting} className="w-100 btn btn-primary-dark mt-4 text-uppercase">
						search now
					</button>
				</div>
				<div className="col-12">
					<button type="button" onClick={clearForm} className="w-100 btn btn-primary btn-ghost mt-4 pl-0 pr-0">
						Clear
					</button>
				</div>
			</form>
			{footer} */}
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	return {
		recipeFoodGroups: get(state, "AddRecipe.recipeFoodGroups.results", []),
		recipeFoodSearchKeyword: get(state, "AddRecipe.recipeFoodSearchKeyword", null),
		atBottom: state.UI.atBottom,
	};
};

const mapDispatchToProps = {
	getFoodGroupList,
	searchFoodNutrition,
	resetForm: reset,
	resetField,
	change,
};

export default reduxForm({
	form: "SearchIngredientsForm",
	enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(SearchFoodNutrition));
